<template>
  <div class="content">
    <NavBar />
    <div class="md-layout py-5">
      <div class="main_section">
        <h3 class="main_section-title">Book now</h3>
        <div class="main_section-content">
          <div class="main_details-content">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
                <stats-card  data-background-color="blue">
                  <template slot="header">
                    <md-icon>store</md-icon>
                  </template>
                  <template slot="content">
                    <h2 class="title font-weight-bold">Booking Details</h2>
                  </template>
<!--                  /////////////////////-->
                  <template slot="content">
                    <div class="stats_content w-100 py-3">
                      <div class="main_details-item">
                        <h4 class="main_details-subtitle">Dates</h4>
                        <div class="md-layout">
<!--                          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">-->
                            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 py-1"><md-icon>schedule</md-icon> Start Date: {{getDate(book_now_data.start_date)}}</div>
                            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 py-1"><md-icon>schedule</md-icon> End Date: {{getDate(book_now_data.end_date)}}</div>
                            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 py-1"><md-icon class="mark_icon"></md-icon> Guests {{book_now_data.guests}}</div>
<!--                            <md-datepicker class="mb-0" v-model="check_in_date_raw" required :md-disabled-dates="disableUnavailableDates">-->
<!--                              <label>Check in</label>-->
<!--                            </md-datepicker>-->
<!--                            <span class="text-danger" v-if="check_errors.start_date">-->
<!--                                {{check_errors.start_date[0]}}-->
<!--                          </span>-->
<!--                          </div>-->
                          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
<!--                            <md-datepicker class="mb-0" v-model="check_out_date_raw" required :md-disabled-dates="disableUnavailableDates">-->
<!--                              <label>Check out</label>-->
<!--                            </md-datepicker>-->
                          </div>
                        </div>
                        <h4 class="main_details-subtitle mt-3">Contact details</h4>
                        <div class="md-layout">
                          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 py-1"><md-icon class="mark_icon"></md-icon> Full Name: {{book_now_data.first_name}} {{book_now_data.last_name}}</div>
                          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 py-1"><md-icon class="mark_icon"></md-icon> Email Address: {{book_now_data.email_address}}</div>
                          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 py-1"><md-icon class="mark_icon"></md-icon> Phone Number: {{book_now_data.phone_number}}</div>
<!--                          <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100">-->
<!--                            <div class="md-layout-item md-small-size-100 md-size-100 px-0">-->
<!--                              <md-field class="mb-0 d-flex">-->
<!--                                <label>Guests</label>-->
<!--                                <md-input v-model="book_now_data.guests" :max="listing_data.person_capacity" type="number" required md-placeholder="Guests" @change="onChange"></md-input>-->
<!--                              </md-field>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          <div class="d-flex align-items-center">-->
<!--                            <md-button class="md-raised md-info m-3" @click="calculate()" :disabled="!book_now_data.start_date || !book_now_data.end_date">Check</md-button>-->
<!--                            <span v-if="check_error" class="text-danger">{{check_error}}</span>-->
<!--                          </div>-->
                        </div>
                      </div>

                        <div class="main_details-item">
                          <div v-if="calculateData" class="md-layout py-3">
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              Nights count:
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              {{calculateData.nights_count}}
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              Nights price:
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              {{ getCurrencySymbol(listing_data.price_and_fee.currency_code) }} {{calculateData.nights_price}} ( {{calculateData.nights_count}} * {{calculateData.price}} )
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              Price for extra person:
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              {{ getCurrencySymbol(listing_data.price_and_fee.currency_code) }} {{calculateData.price_for_extra_person}}
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              Price for 1 night:
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              {{ getCurrencySymbol(listing_data.price_and_fee.currency_code) }} {{calculateData.price}}
                            </div>
                            <md-divider class="w-100 my-1"></md-divider>
                            <div class="md-layout-item md-small-size-100 md-size-50 font-weight-bold">
                              Total
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50 font-weight-bold">
                              {{ getCurrencySymbol(listing_data.price_and_fee.currency_code) }} {{calculateData.total_price}}
                            </div>
                          </div>
                        </div>
                    </div>
                  </template>
                </stats-card>
              </div>
              <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
                <stats-card  data-background-color="blue">
                  <template slot="header">
                    <md-icon>payments</md-icon>
                  </template>
                  <template slot="content">
                    <h2 class="title font-weight-bold">Payment Information</h2>
                  </template>
                  <!--                  /////////////////////-->
                  <template slot="content">
                    <div class="stats_content w-100 py-3">
                      <form @submit.prevent="submitForm" class="w-100 d-flex flex-column">
                        <div class="main_details-item">
                          <h4 class="main_details-subtitle">Billing Address</h4>
                          <div class="md-layout">
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              <md-field>
                                <label>Billing Address</label>
                                <md-input v-model="book_now_data.billing_address" md-placeholder="Billing Address"></md-input>
                              </md-field>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              <md-field>
                                <label>City</label>
                                <md-input v-model="book_now_data.city" md-placeholder="City"></md-input>
                              </md-field>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              <md-field>
                                <label>Country</label>
                                <md-input v-model="book_now_data.country" md-placeholder="Country"></md-input>
                              </md-field>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              <md-field>
                                <label>Zip code</label>
                                <md-input v-model="book_now_data.zip_code" md-placeholder="Zip code"></md-input>
                              </md-field>
                            </div>

                          </div>
                          <p class="main_details-line"></p>
                        </div>
                        <div class="main_details-item">
                          <h4 class="main_details-subtitle">Payment</h4>
                          <div class="md-layout">
                            <div class="md-layout-item md-small-size-100 md-size-50">
                              <div id="card-element"></div>
                            </div>
                          </div>
                          <p class="main_details-line"></p>
                        </div>
                        <md-button class="md-raised md-info" :disabled="isPayDisabled" type="submit">Pay</md-button>
                        <span v-if="check_error" class="text-danger">{{check_error}}</span>
                      </form>
                    </div>
                  </template>
                </stats-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />

    <md-dialog :md-active.sync="showSuccessModal" class="booking-success-dialog">
      <md-dialog-title class="booking-success-title">
        <md-icon class="booking-success-icon">check_circle</md-icon>
        Booking successful
      </md-dialog-title>
      <md-dialog-content class="booking-success-content">
        Booking successfully done, thank you.
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised md-info" @click="closeSuccessAndGoHome">OK</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import {loadStripe} from "@stripe/stripe-js";
import {mapActions} from "vuex";
import axios from "axios";
import {StatsCard} from "@/components";
export default {
  name: "BookNow",
  components: {
    Footer,
    NavBar,
    StatsCard
  },
  data() {
    return {
      check_error: '',
      check_errors: [],
      email_status: null,
      check_in_date_raw: null,
      check_out_date_raw: null,
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      stripe: null,
      cardElement: null,
      reservedDates: [],
      inquiry_errors: [],
      error: '',
      listing_data: {},
      book_now_data: {
        listing_id: null,
        start_date: null,
        end_date: null,
        guests: null,
        first_name: null,
        last_name: null,
        email_address: null,
        phone_number: null,
        promotional_emails: 0,
        billing_address: null,
        city: null,
        country: 'US',
        zip_code: null,
        stripe_payment_method_id: null,
      },
      calculateData: null,
      isPayDisabled: true, // initially disabled
      isProcessing: false, // to lock after click
      showSuccessModal: false
    }
  },
  async mounted() {
    const stripeKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
    this.stripe = await loadStripe(stripeKey, { locale: 'en' })
    const elements = this.stripe.elements({ locale: 'en' })
    this.cardElement = elements.create('card', { hidePostalCode: true })
    this.$nextTick(() => {
      this.cardElement.mount("#card-element");
    });
  },
  created() {
    try {
      this.listing_data = JSON.parse(localStorage.getItem('listingDetails')) || {}
    } catch (e) {
      this.listing_data = {}
    }

    const inquiryData = this.$route.params.inquiry_data
    const savedBookNowData = this.getSavedBookNowData()

    if (inquiryData) {
      this.check_in_date_raw = inquiryData.start_date ? new Date(inquiryData.start_date) : null
      this.book_now_data.start_date = inquiryData.start_date
      this.check_out_date_raw = inquiryData.end_date ? new Date(inquiryData.end_date) : null
      this.book_now_data.end_date = inquiryData.end_date
      this.book_now_data.first_name = inquiryData.first_name
      this.book_now_data.last_name = inquiryData.last_name
      this.book_now_data.email_address = inquiryData.email_address
      this.book_now_data.phone_number = inquiryData.phone_number
      this.book_now_data.guests = inquiryData.guests || this.listing_data.guests || 1
      this.book_now_data.listing_id = inquiryData.listing_id || this.listing_data.id
      this.saveBookNowData()
    } else if (savedBookNowData) {
      Object.assign(this.book_now_data, savedBookNowData)
      if (savedBookNowData.start_date) this.check_in_date_raw = new Date(savedBookNowData.start_date)
      if (savedBookNowData.end_date) this.check_out_date_raw = new Date(savedBookNowData.end_date)
    } else {
      this.book_now_data.guests = this.listing_data.guests || 1
    }

    this.getAllReservedDates()
    this.calculate()
  },
  watch: {
    check_in_date_raw(val) {
      this.book_now_data.start_date = this.formatDate(val);
    },
    check_out_date_raw(val) {
      this.book_now_data.end_date = this.formatDate(val);
    },
    book_now_data: {
      deep: true,
      handler() {
        this.validateForm();
        this.saveBookNowData();
      }
    },
    showSuccessModal(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    ...mapActions(['getReservedDates', 'calculatePrice', 'checkBlockEmail']),
    getSavedBookNowData() {
      try {
        const saved = localStorage.getItem('bookNowData')
        if (saved) {
          const data = JSON.parse(saved)
          if (data.listing_id === this.listing_data?.id) return data
        }
      } catch (e) {
        console.error('Failed to load saved booking data:', e)
      }
      return null
    },
    saveBookNowData() {
      try {
        if (this.listing_data?.id && this.book_now_data.start_date && this.book_now_data.end_date) {
          const { stripe_payment_method_id, ...dataToSave } = this.book_now_data
          localStorage.setItem('bookNowData', JSON.stringify({
            ...dataToSave,
            listing_id: this.listing_data.id
          }))
        }
      } catch (e) {
        console.error('Failed to save booking data:', e)
      }
    },
    clearSavedBookNowData() {
      localStorage.removeItem('bookNowData')
    },
    closeSuccessAndGoHome() {
      this.showSuccessModal = false
    },
    validateForm() {
      const { billing_address, city, country } = this.book_now_data;
      this.isPayDisabled =
          !billing_address || !city || !country || this.isProcessing;
    },
    checkEmail() {
      this.inquiry_errors = []
      this.email_status = null
      if (this.book_now_data.email_address != null && this.book_now_data.email_address != '') {
        let validEmail = this.validateEmail(this.book_now_data.email_address)
        if(validEmail) {
          this.checkBlockEmail(this.book_now_data.email_address)
              .then(res => {
                if(res.status == 200) {
                  this.email_status = 1
                } else {
                  this.email_status = 0
                  this.inquiry_errors = {email_address: ["Email is blocked"] }
                }
              })
        } else {
          this.inquiry_errors = {email_address: ['Invalid email address'] }
        }
      }
    },
    validateEmail(email) {
      const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
      return emailRegex.test(email)
    },
    getCurrencySymbol(currencyCode) {
      try {
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        // Extract symbol by formatting a value and removing the digits
        const parts = formatter.formatToParts(1);
        const symbolPart = parts.find(part => part.type === 'currency');
        return symbolPart ? symbolPart.value : currencyCode;
      } catch (e) {
        return currencyCode; // fallback if the currency code is invalid
      }
    },
    calculate() {
      this.error = ''
      this.book_now_data.listing_id = this.listing_data.id
      this.calculatePrice(this.book_now_data)
          .then(res => {
            if(res.status == 200) {
              this.calculateData = res.data
            } else {
              if(res.error) {
              } else {

              }
            }
          })
    },
    disableUnavailableDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const formattedDate = this.formatDate(date);
      const isReserved = this.reservedDates.some(d => this.formatDate(d) === formattedDate);
      return date < today || isReserved;
    },
    getDate(input) {
      const date = new Date(input);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    onChange() {
      if (this.inquiry_data.guests <= this.listing_data.person_capacity) {
        return  this.inquiry_data.guests;
      } else {
        this.inquiry_data.guests = 1
      }
      this.getAllReservedDates()
    },
    formatDate(date) {
      if (!date) return '';
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2);
      const day = (`0${date.getDate()}`).slice(-2);
      return `${year}-${month}-${day}`;
    },
    getAllReservedDates() {
      let sendData = {
        listing_id: this.listing_data.id,
        guests: this.book_now_data.guests
      }
      this.getReservedDates(sendData)
          .then(res => {
            if (res.data && Array.isArray(res.data.unavailable_dates)) {
              this.reservedDates = res.data.unavailable_dates.map(dateStr => new Date(dateStr));
            }
          })
    },
    async submitForm() {
      this.check_error = ''
      // this.isProcessing = true;
      // this.isPayDisabled = true;
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardElement,
        billing_details: {
          name: `${this.book_now_data.first_name} ${this.book_now_data.last_name}`,
          address: {
            line1: this.book_now_data.billing_address,
            city: this.book_now_data.city,
            postal_code: this.book_now_data.zip_code,
            country: this.book_now_data.country,
          },
        },
      })
      if (error) {
        alert(error.message)
        return
      }
      let baseURL = process.env.VUE_APP_BASE_URL
      try {
        await axios.post(`${baseURL}bookings`, {
          // billing: this.form.billing,
          stripe_payment_method_id: paymentMethod.id,
          listing_id: this.listing_data.id,
          start_date: this.book_now_data.start_date,
          end_date: this.book_now_data.end_date,
          guests: this.book_now_data.guests,
          first_name: this.book_now_data.first_name,
          last_name: this.book_now_data.last_name,
          email_address: this.book_now_data.email_address,
          phone_number: this.book_now_data.phone_number,
          promotional_emails: this.book_now_data.promotional_emails,
          billing_address: this.book_now_data.billing_address,
          city: this.book_now_data.city,
          country: this.book_now_data.country,
          zip_code: this.book_now_data.zip_code,
        })
        .then(res => {
          console.log(res, 'res')
          this.clearSavedBookNowData()
          this.book_now_data.billing_address = ""
          this.book_now_data.city = ""
          this.book_now_data.country = "US"
          this.book_now_data.zip_code = ""
          this.cardElement.clear()
          this.showSuccessModal = true
        })
      } catch (err) {
        console.log(err, 'err')
        console.error(err)
        this.check_error = err.response.data.error
        // this.isProcessing = false;
        this.validateForm(); // re-enable if error
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  &_section {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 80px 60px 50px;
    &-title {
      color: #000;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      @media screen and (max-width: 1680px) {
        font-size: 28px;
      }
      @media screen and (max-width: 1440px) {
        font-size: 26px;
      }
      @media screen and (max-width: 768px) {
        font-size: 18px;
      }
      @media screen and (max-width: 440px) {
        font-size: 15px;
      }
    }
    &-error {
      padding: 20px;
      font-size: 20px;
      background: #f34242;
      color: #fff;
      font-weight: 600;
      margin-bottom: 50px;
    }
  }
  &_details {
    &-content {
      padding-top: 30px;
      ::v-deep .md-card-stats .md-card-content {
        text-align: start !important;
      }
    }
    &-item {
      padding: 15px 0;
    }
    &-title {
      font-weight: 600;
      font-size: 24px;
      padding-left: 15px;
    }
    &-subtitle {
      padding-left: 15px;
    }
    &-line {
      margin: 10px 0;
      border-bottom: 1px solid #1E1E1E;
    }
  }
}
input[type='number'] {
  -moz-appearance:textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.valid_status {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2px;
  &.success {
    border-bottom: 2px solid #009b00;
  }
  &.error {
    border-bottom: 2px solid #e90000;
  }
}
.he-8 {
  height: 80px;
  display: inline-table !important;
}
.md-layout {
  & .mark_icon {
    width: 24px;
    height: 24px;
    background: url("~@/assets/icons/check_ circle.svg");
  }
}

.booking-success-dialog {
  .booking-success-title {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #000;
    font-weight: 700;
    font-size: 24px;
    padding: 24px 24px 0;
  }
  .booking-success-icon {
    color: #00bcd4 !important;
    font-size: 36px !important;
  }
  .booking-success-content {
    padding: 20px 24px;
    color: #1E1E1E;
    font-size: 16px;
  }
  .md-dialog-actions {
    padding: 16px 24px 24px;
  }
}
</style>
